import React from 'react'
import { useSelector } from 'react-redux'
import { getDisplayOptions } from '../redux/options/selectors' 
import { getFastestPerDay } from '../redux/data/selectors' 
import { Divider, Panel } from 'rsuite'
import Icon from './Icon'

const Summary = ( props ) => { 
  
  const { 
    rows, 
    before = null,
    after = null,
    ...show 
  } = props

  // get display options
  const display = useSelector( getDisplayOptions )
  const fastest_row = useSelector( getFastestPerDay )

  // stop righ away if user doesn't want to show the summary
  if ( !display.summary ) return null

  // get unique cars
  const cars = [ ...new Set( rows.map( d => d[ 'car' ] ) ) ].length

  // calculate number of cones
  const cones = rows.reduce( ( total, row ) => {
    // take missing / empty penalty into account
    if ( row.hasOwnProperty( 'penalty' ) && row.penalty > 0 )
    {
      return total + row.penalty
    }
    return total
  }, 0 ) / 5

  // get fastest time of the current screen
  const fastest = rows.reduce( ( total, row ) => {
    if ( !total || row.laptime < total ) 
    {
      if ( !row.penalty && !row.comment )
      {
        return row.laptime
      }
    }
    return total
  }, '' )

  /**
   * Get children based on show prop
   * @returns 
   */
  const getChildren = () => 
  {
    const children = []
    
    if ( before )
    {
      children.push( <div key="before" className="before col">{ before }</div> )
    }
    
    if ( show.car ) 
    {
      children.push( <div key="cars" className="cars col"><Icon icon="car"/> <b>{ cars }</b></div>  )
    }

    if ( show.laps ) 
    {
      children.push( <div key="laps" className="laps col"><Icon icon="flag"/> <b>{ rows.length }</b></div> )
    }

    if ( show.cones ) 
    {
      children.push( <div key="cones" className="cones col"><Icon icon="cone"/> <b>{ cones }</b> </div> )
    }

    if ( show.time ) 
    {
      // green of fast time, purple if fastest 
      let className = fastest_row && fastest_row.laptime === fastest ? 'fastest' : 'fast'
      children.push( <div key="time" className={ className + ' col'}><Icon icon="stopwatch"/> <b>{ fastest ? fastest : '00:00.000'}</b></div> )
    }
    
    if ( after )
    {
      children.push( <div key="after" className="after col">{ after }</div> )
    }

    // append divider if needed
    return children.map( ( child, index ) => (
        <React.Fragment key={ index }>
          { child }
          { index !== children.length - 1 ? <Divider key={ `div-${index}` } vertical/>  : null }
        </React.Fragment>
    ) )
  }

  return (
    <Panel bordered className="summary">{ getChildren() }</Panel>
  )
}

export default Summary